import React, { useState } from "react"
import styled from "styled-components"

const Switch = styled.label`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  color: white;
  margin: 27px 0 10px 0;
  border: 1px solid white;
  border-radius: 0.25rem;

  @media (max-width: 600px) {
    padding-top: 10px;
  }


  ::selection {
    background: none;
  }

  span {
    color: ${props => props.theme.secondaryTextColor};
    font-family: ${props => props.theme.primaryFont};
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    width: 100%;
    border: 1px solid #6b706a;
    padding: 10px 65px;

    @media (max-width: 600px) {
      padding: 10px;
    }
  }

  span.active {
    border: 2px solid #eb2e40;
    color: black;
    background-color: #fff5f6;
    font-weight: bold;
  }
`

const SwitchInput = styled.input`
  display: none;
  box-sizing: border-box;

  &:checked {
  }
`

const CheckboxSwitch = props => {
  const [checked, setChecked] = useState(props.checked)
  return (
    <>
      <SwitchInput
        id={props.id || "switchInput"}
        type="checkbox"
        checked={checked}
      />
      <Switch
        htmlFor={props.id || "switchInput"}
        checked={checked}
        onClick={() => {
          setChecked(!checked)
          console.log(checked)
        }}
      >
        <span className={checked ? "active" : null}>Contributor</span>
        <span className={checked ? null : "active"}>Admin School</span>
      </Switch>
    </>
  )
}

export default CheckboxSwitch
